import { schema } from 'normalizr';

const accountGOSAgreementTransactions = new schema.Entity(
  'accountGOSAgreementTransactions'
);

export default accountGOSAgreementTransactions;
